import { render, staticRenderFns } from "./MulitpleChartsFrame.vue?vue&type=template&id=80155876&scoped=true"
import script from "./MulitpleChartsFrame.vue?vue&type=script&lang=js"
export * from "./MulitpleChartsFrame.vue?vue&type=script&lang=js"
import style0 from "./MulitpleChartsFrame.vue?vue&type=style&index=0&id=80155876&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80155876",
  null
  
)

export default component.exports